Oskari.lazyBundle('file-layerlist', function() {return import(/* webpackChunkName: "chunk_file-layerlist" */ 'oskari-bundle!/opt/oskari/bundles/file-layerlist/index.js');});
